import React from "react";
import { Layout, Button, Typography, Dropdown, Menu } from "antd";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Header } = Layout;
const { Title } = Typography;

const AppHeader = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  const userMenu = (
    <Menu>
      <Menu.Item key="1" icon={<UserOutlined />}>
        Profile
      </Menu.Item>
      <Menu.Item key="2" icon={<LogoutOutlined />} onClick={handleLogout}>
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <Header
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 20px",
        background: "#001529",
        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
      }}
    >
      {/* Logo atau Judul */}
      <Title level={3} style={{ color: "white", margin: 0 }}>
        {/* Daily Meeting Task */}
      </Title>

      {/* User Dropdown */}
      <Dropdown overlay={userMenu} placement="bottomRight">
        <Button type="text" style={{ color: "white", fontWeight: "bold" }}>
          Admin <UserOutlined />
        </Button>
      </Dropdown>
    </Header>
  );
};

export default AppHeader;
